<template>
    <transition name="fade">
        <small-alert v-if="active" :item="current" />
    </transition>
</template>

<script>
import SmallAlert from "@/components/custom/maddy/SmallAlert";
export default {
    name: "SocialMedias",
    data: () => ({
        active: false,
        current: {
            image: null,
            icon: "",
            text: "",
        },
        counter: null,
        items: [
            {
                image: null,
                icon: "fab fa-twitter",
                text: "@madeleineink",
            },
            {
                image: null,
                icon: "fab fa-instagram",
                text: "lucky.melon",
            },
            {
                image: null,
                icon: "fab fa-instagram",
                text: "madeleineink",
            },
            {
                image: null,
                icon: "fab fa-artstation",
                text: "madeleinebellwoar",
            },
            {
                image: null,
                icon: "fab fa-twitch",
                text: "Enjoying the stream? Press follow!",
            },
            {
                image: null,
                icon: "fab fa-twitch",
                text:
                    "Want to support the stream? Subscribe and get access to exclusive paintings",
            },
        ],
    }),
    mounted() {
        this.current = this.items[1];
        this.active = true;

        this.counter = setInterval(() => {
            this.active = false;
            this.next();
        }, 1000 * 30);
    },
    methods: {
        rotate() {
            this.next();
        },
        next() {
            let index = this.items.indexOf(this.current) + 1;
            if (index >= this.items.length) index = 0;

            this.current = this.items[index];
        },
    },
    components: {
        SmallAlert,
    },
};
</script>

<style></style>
